import { render, staticRenderFns } from "./AddAlarms.html?vue&type=template&id=489d7c94&scoped=true&external"
import script from "./AddAlarms.js?vue&type=script&lang=js&external"
export * from "./AddAlarms.js?vue&type=script&lang=js&external"
import style0 from "./AddAlarms.scss?vue&type=style&index=0&id=489d7c94&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d7c94",
  null
  
)

export default component.exports